module.exports = "/_next/static/images/UseSegment-426e1f448fee2a7cad08076cfd0c9248.webp";